import script from "./dependences.vue?vue&type=script&setup=true&lang=js"
export * from "./dependences.vue?vue&type=script&setup=true&lang=js"

import "./dependences.vue?vue&type=style&index=0&id=f15c870e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f15c870e"]])

export default __exports__